/**
 * Class name joiner.
 *
 * Mirrors the standalone React library's `cn()` in spirit, minus `tailwind-merge`
 * which has nothing to do here: we emit design-system class names, not utilities,
 * so there are no conflicting utilities to dedupe.
 *
 * The rule that DOES carry over: a consumer's `className` is always passed LAST
 * so it wins. Every component in this library must end its class list with
 * `cn(..., className)`.
 */
export function cn(...inputs) {
  const out = [];

  for (const input of inputs) {
    if (!input) continue;

    if (typeof input === 'string') {
      out.push(input);
    } else if (Array.isArray(input)) {
      const nested = cn(...input);
      if (nested) out.push(nested);
    } else if (typeof input === 'object') {
      for (const key of Object.keys(input)) {
        if (input[key]) out.push(key);
      }
    }
  }

  return out.join(' ');
}

export default cn;
